var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 89,
    viewBox: "0 0 104 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    fill: "#FBFCFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6355 32.4321C57.9832 26.812 70.021 26.3038 80.1358 32.1436C90.2506 37.9834 95.8294 48.6626 95.6361 59.5679C86.2885 65.188 74.2506 65.6962 64.1358 59.8564C54.021 54.0166 48.4422 43.3374 48.6355 32.4321Z",
    fill: "#E4ECFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0102 58.1904C71.735 62.0729 80.3339 59.7688 84.2165 53.044C88.099 46.3193 85.795 37.7203 79.0702 33.8377C72.3454 29.9552 63.7464 32.2593 59.8638 38.984C55.9813 45.7088 58.2854 54.3078 65.0102 58.1904Z",
    fill: "#508AF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.66 51.8683C71.8932 53.735 76.0276 52.6273 77.8943 49.394C79.761 46.1607 78.6532 42.0264 75.42 40.1597C72.1867 38.2929 68.0524 39.4007 66.1856 42.634C64.3189 45.8673 65.4267 50.0016 68.66 51.8683Z",
    fill: "#1953D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1097 31.7844C39.1097 28.9786 39.0142 26.2204 39.062 23.4146C39.1097 21.6075 39.253 22.0831 37.1996 21.8929C34.3344 21.6075 33.3794 26.9337 33.1406 29.2164C32.8541 32.4026 33.5704 35.779 34.0957 38.9176C34.2867 40.0114 34.2389 42.2941 35.385 42.8172C36.3878 43.2452 37.4384 42.1514 37.9636 41.343C39.1575 39.4408 38.9665 36.5874 39.062 34.4474C39.062 33.5439 39.1097 32.6404 39.1097 31.7844Z",
    fill: "#508AF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.624 49.2847H30.7055V58.4954L38.2978 61.3161C38.2978 61.3161 42.1657 62.3623 44.6011 66.1191H4.72754C7.16293 62.3623 11.0309 61.3161 11.0309 61.3161L18.624 58.4951V49.2847Z",
    fill: "#E4ECFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7532 54.7535V49.2847H18.624V51.9953C22.11 54.8486 26.2645 55.2291 30.7532 54.7535Z",
    fill: "#C7D9FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8685 47.6679C36.6269 52.4235 34.478 53.755 34.478 53.755L31.5651 54.3257C29.8937 54.1355 27.0286 53.4221 27.0286 53.4221C20.4387 51.187 18.5286 50.5688 17.478 48.0959C17.478 47.9533 12.3207 30.12 12.3207 30.12C11.4611 20.9419 21.1072 19.0397 22.5876 18.8019C24.0201 18.469 33.2364 15.9486 35.9106 24.7463C35.9106 24.7463 39.9218 34.9231 37.8685 47.6679Z",
    fill: "#E4ECFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3174 21.7026C8.11794 23.2244 8.02243 26.0777 8.16569 29.3115C8.2612 31.8319 9.07299 33.9719 9.9803 36.3972C11.5084 40.5821 11.5084 40.5821 12.8455 42.9598C12.8455 42.9598 14.9943 46.2411 17.7163 48.5238C16.9045 45.3852 16.7134 43.0549 15.9972 40.6772C15.1376 37.7763 15.3764 33.9243 16.6657 30.9759C16.6657 30.9759 17.382 29.0261 20.3904 28.4555C23.3988 27.8848 20.3904 28.4555 20.3904 28.4555L11.3174 21.7026Z",
    fill: "#508AF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5699 40.0114C16.5699 40.0114 14.9463 36.4923 12.3676 38.5847C12.3676 38.5847 11.2215 39.4883 12.6541 41.8661C12.6541 41.8661 14.7552 45.29 17.2384 43.3878L16.5699 40.0114Z",
    fill: "#E4ECFD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3318 31.7844C16.3318 31.7844 16.3318 38.1093 17.5256 41.4857L16.284 41.7235C16.284 41.7235 15.6155 37.3959 13.3711 37.3484L16.3318 31.7844Z",
    fill: "#508AF2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6858 18.1835C51.0004 28.6457 19.77 28.5506 19.77 28.5506C19.77 28.5506 16.4751 30.0723 11.3178 21.7026C11.3178 21.7026 9.93296 15.14 24.6886 13.0951C24.6886 13.0951 34.4301 11.9062 40.6858 18.1835Z",
    fill: "#508AF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35001 84H0C2.83333 85.3333 12.2 88 27 88C41.7999 88 49.1666 85.3334 51 84H51.0001C51.0001 81.5747 50.8569 78.1032 50.8569 78.1032C49.9973 63.5512 39.3962 61.2686 39.3962 61.2686C39.2476 61.2329 39.1032 61.2019 38.9628 61.1755L30.7531 58.5105C30.7531 58.5105 32.5677 61.6967 24.6408 61.6967C24.6408 61.6967 19.4357 61.5065 18.6717 58.5105L9.88515 61.3163C9.88515 61.3163 8.84173 61.5744 7.46646 62.3054C3.4934 63.7407 1.65438 67.324 0.907303 71.3503C0.33427 74.3938 0.143258 77.5325 0.0477528 80.6235C0.0477528 80.8613 0 84 0 84H5.35001L5.35001 84Z",
    fill: "#508AF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentUsers);
export default __webpack_public_path__ + "static/media/recent-users.0161af60b7e305fb791b23978231ac4d.svg";
export { ForwardRef as ReactComponent };